import React from 'react'
import { Outlet } from 'react-router-dom'
import DataManagementNesting from './DataManagementNesting'

const DataManagementNestingContainer = (): React.ReactNode => {
  return (
    <>
      <Outlet />
      <DataManagementNesting />
    </>
  )
}

export default DataManagementNestingContainer
